module.exports = new __parcel__URL__("shop_holder_exclusive_button.6530eb04.png").toString();